import MoveSpec from "./MoveSpec";
export default MoveSpec;
